import Client from '../HttpClient';

const list = () => {
	return Client.get('/admin/api/machine');
};

/**
 * @param {int} type 0-POS Terminal, 1-Kitchen Screen, 2-Kiosk
 */
const listByType = (type) => {
	return Client.get(`/admin/api/machine/list-type/${type}`);
};

const find = (id) => {
	return Client.get(`/admin/api/machine/${id}`);
};

const update = (id, payload) => {
	return Client.put(`/admin/api/machine/${id}`, payload);
};

const create = (payload) => {
	return Client.post(`/admin/api/machine`, payload);
};

const remove = (id) => {
	return Client.del(`/admin/api/machine/${id}`);
};

const unbind = (id) => {
	return Client.put(`/admin/api/machine/unbind/${id}`);
};

export default {
	list,
	listByType,
	find,
	create,
	update,
	remove,
	unbind,
};
